import type { ReactNode } from 'react';

export const symbol_file_copy: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M780-160H260q-24 0-42-18t-18-42v-640q0-24 18-42t42-18h323q12.44 0 23.72 5T626-902l196 196q8 8 13 19.28 5 11.28 5 23.72v443q0 24-18 42t-42 18Zm0-502H623q-18.75 0-31.87-13.13Q578-688.25 578-707v-153H260v640h520v-442ZM140-40q-24 0-42-18t-18-42v-589q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v589h468q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q620.75-40 608-40H140Zm120-820v198-198 640-640Z"
		/>
	</svg>
);
